/**
 * Wrapper function for calling a async function in a useEffect hook.
 * @param fn target async function
 */
export function asyncInvoke(fn: any): () => void {
    return () => {
        fn();
    };
}
